/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { BottomSheet, Tooltip } from '@s4l/ds'
import cn from 'classnames'
import dynamic from 'next/dynamic'
import React, { useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import { useClickAway } from 'react-use'
import Dropdown from 'src/comps/Atom/Drowpdown'
import { useDevice } from 'src/hooks/useDevice'
import { useKafkaEvent } from 'src/hooks/useKafkaEvent'
import { SECTIONS } from 'src/hooks/useKafkaEvent/constants'
import { usePage } from 'src/hooks/usePage'
import { BreakpointSizes } from 'src/types/device'
import { ShareContent } from '../Content'

import styles from './styles.module.css'

const ShareIOSIcon = dynamic(() => import('client/icons/ShareIOSIcon'), {
  ssr: false,
})
const ShareAndroidIcon = dynamic(() => import('client/icons/ShareAndroidIcon'), {
  ssr: false,
})

interface ShareModalInterface {
  defaultOpen?: boolean
  propertyId: number
}

const ShareButton = ({
  handleClick,
  active = false,
}: {
  handleClick: () => void
  active?: boolean
}) => {
  const { isApple } = useDevice()

  const ShareIcon = isApple ? ShareIOSIcon : ShareAndroidIcon
  return (
    <span
      className={cn(styles.newShare, {
        [styles.active]: active,
      })}
    >
      <ShareIcon className="share-icon" onClick={handleClick} />
    </span>
  )
}

const ShareModal = ({ defaultOpen = false, propertyId }: ShareModalInterface) => {
  const intl = useIntl()
  const [isOpen, setIsOpen] = useState(defaultOpen)
  const { activeBreakpoint } = useDevice()

  const { pageId } = usePage()
  const { sendEvent } = useKafkaEvent({ page: pageId, eventName: 'click' })

  const container = useRef<HTMLDivElement>(null)
  useClickAway(container, () => setIsOpen(false))

  function handleClick() {
    setIsOpen(true)
    sendEvent({ section: SECTIONS.SHARE_MODAL }, { propertyId })
  }

  const isWide = activeBreakpoint > BreakpointSizes.M

  if (isWide) {
    return (
      <Tooltip enabled={!isOpen} delayClose={0} delayOpen={0}>
        <Tooltip.Trigger>
          <div ref={container} className={styles.dropdownContainer}>
            <Dropdown
              trigger={<ShareButton handleClick={handleClick} active={isOpen} />}
              show={isOpen}
              showClose={false}
            >
              <ShareContent className={styles.wideDropdown} propertyId={propertyId} />
            </Dropdown>
          </div>
        </Tooltip.Trigger>
        <Tooltip.Content animation="fade">
          {intl.formatMessage({ id: 'global.share-hotel' })}
        </Tooltip.Content>
      </Tooltip>
    )
  }

  return (
    <>
      <ShareButton active={isOpen} handleClick={handleClick} />
      <BottomSheet
        open={isOpen}
        shouldScaleBackground={false}
        noBodyStyles
        onOpenChange={setIsOpen}
      >
        <BottomSheet.Content
          contentPadding={false}
          data-testid="cta-choose-room"
          aria-describedby=""
          title={intl.formatMessage({
            id: 'global.share',
          })}
        >
          <ShareContent propertyId={propertyId} />
        </BottomSheet.Content>
      </BottomSheet>
    </>
  )
}

export default ShareModal
